import { Outlet } from 'react-router-dom'

import { AccountWrapper } from './AccountWrapper'
import { OreStack } from '@edenredespana/oreneta'

export const AccountLayout = (): JSX.Element => {
  return (
    <>
      <AccountWrapper>
        <OreStack space="xlarge" placeContent="center" placeItems="center">
          <Outlet />
        </OreStack>
      </AccountWrapper>
    </>
  )
}
